module.exports = __webpack_public_path__ + "static/media/competitors_image2.83a5456c.webp";